// Russian labels + status mappings for construction domain
export const STATUS_LIST = [
  "Anfrage",
  "Angebot erstellt",
  "Beauftragt",
  "In Arbeit",
  "Abgeschlossen",
  "Storniert",
];

export const STATUS_META = {
  Anfrage: {
    label_ru: "Заявка",
    cls: "bg-purple-500/15 text-purple-300 border-purple-500/30",
  },
  "Angebot erstellt": {
    label_ru: "КП создано",
    cls: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  },
  Beauftragt: {
    label_ru: "Подтверждено",
    cls: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  },
  "In Arbeit": {
    label_ru: "В работе",
    cls: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
  },
  Abgeschlossen: {
    label_ru: "Завершено",
    cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  },
  Storniert: {
    label_ru: "Отменено",
    cls: "bg-red-500/15 text-red-300 border-red-500/30",
  },
};

export const GEWERKE = [
  { de: "Trockenbau", ru: "Гипсокартон" },
  { de: "Malerarbeiten", ru: "Малярка" },
  { de: "Bodenbelag", ru: "Напольные" },
  { de: "Dämmung", ru: "Утепление" },
  { de: "Fenster/Türen", ru: "Окна/Двери" },
  { de: "Fassade", ru: "Фасад" },
];

// Stored/wire value for a trade category is the German term (de) above —
// this only maps it to its Russian label for display.
export function gewerkRu(de) {
  return GEWERKE.find((g) => g.de === de)?.ru || de;
}

// Single source of truth for a client's Privat/Firma type: legacy client
// documents predate the client_type field, so it must never be read raw —
// always go through this helper (list cards, filters, stats, Workspace).
export function resolveClientType(client) {
  if (client?.client_type === "privat" || client?.client_type === "firma") return client.client_type;
  return client?.company ? "firma" : "privat";
}

export const LEAD_STATUS = [
  { value: "Kalt", label: "Холодный", cls: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
  { value: "Warm", label: "Тёплый", cls: "bg-amber-500/20 text-amber-300 border-amber-500/30" },
  { value: "Auftrag", label: "Клиент", cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
];

export const QUOTE_STATUS = {
  draft:    { label: "Черновик", cls: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
  sent:     { label: "Отправлено", cls: "bg-blue-500/20 text-blue-300 border-blue-500/30" },
  accepted: { label: "Принято",   cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
  rejected: { label: "Отклонено", cls: "bg-red-500/20 text-red-300 border-red-500/30" },
};

export function fmtEur(v) {
  if (v == null || isNaN(v)) return "—";
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(v);
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("ru-RU", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("ru-RU", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
}
export const CONTRACT_STATUS = {
  draft:         { label: "Черновик",       cls: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
  sent:          { label: "Отправлен",      cls: "bg-blue-500/20 text-blue-300 border-blue-500/30" },
  signed:        { label: "Подписан",       cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
  cancelled:     { label: "Отменён",        cls: "bg-slate-500/20 text-slate-500 border-slate-500/30" },
  uploaded:      { label: "Загружено",       cls: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
  processing:    { label: "Обработка",       cls: "bg-blue-500/20 text-blue-300 border-blue-500/30" },
  needs_review:  { label: "Нужна проверка",  cls: "bg-amber-500/20 text-amber-300 border-amber-500/30" },
  approved:      { label: "Одобрено",        cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
  planning:      { label: "Планирование",    cls: "bg-cyan-500/20 text-cyan-300 border-cyan-500/30" },
  active:        { label: "В работе",        cls: "bg-purple-500/20 text-purple-300 border-purple-500/30" },
  completed:     { label: "Завершено",       cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
  rejected:      { label: "Отклонено",       cls: "bg-red-500/20 text-red-300 border-red-500/30" },
};

export const CONTRACT_SOURCE = {
  crm_upload:   "Загружено в CRM",
  email:        "Почта",
  google_drive: "Google Drive",
};

export const AI_STATUS = {
  not_started:  { label: "—",              cls: "bg-slate-500/20 text-slate-400 border-slate-500/30" },
  extracting:   { label: "AI: анализ",     cls: "bg-blue-500/20 text-blue-300 border-blue-500/30" },
  extracted:    { label: "AI: готово",     cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
  needs_review: { label: "AI: проверить",  cls: "bg-amber-500/20 text-amber-300 border-amber-500/30" },
  approved:     { label: "AI: одобрено",   cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
  failed:       { label: "AI: ошибка",     cls: "bg-red-500/20 text-red-300 border-red-500/30" },
};

export const REMINDER_PRIORITY = {
  low:    { label: "Низкий",   cls: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
  normal: { label: "Обычный",  cls: "bg-blue-500/20 text-blue-300 border-blue-500/30" },
  high:   { label: "Высокий",  cls: "bg-red-500/20 text-red-300 border-red-500/30" },
};

export const REMINDER_STATUS = {
  open:      { label: "Открыто",    cls: "bg-blue-500/20 text-blue-300 border-blue-500/30" },
  snoozed:   { label: "Отложено",   cls: "bg-amber-500/20 text-amber-300 border-amber-500/30" },
  done:      { label: "Готово",     cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
  cancelled: { label: "Отменено",   cls: "bg-slate-500/20 text-slate-500 border-slate-500/30" },
};

export const COMMERCIAL_STAGE = {
  auftrag:                 { label: "Auftrag", cls: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
  vertrag_offen:           { label: "Vertrag offen", cls: "bg-amber-500/20 text-amber-300 border-amber-500/30" },
  vertrag_unterschrieben:  { label: "Vertrag unterschrieben", cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
  anzahlung_offen:         { label: "Anzahlung offen", cls: "bg-amber-500/20 text-amber-300 border-amber-500/30" },
  anzahlung_bezahlt:       { label: "Anzahlung bezahlt", cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
  arbeit_freigegeben:      { label: "Arbeit freigegeben", cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
  in_arbeit:               { label: "In Arbeit", cls: "bg-cyan-500/20 text-cyan-300 border-cyan-500/30" },
  teilabnahme:             { label: "Teilabnahme", cls: "bg-blue-500/20 text-blue-300 border-blue-500/30" },
  abnahme_erfolgt:         { label: "Abnahme erfolgt", cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
  rechnung_offen:          { label: "Rechnung offen", cls: "bg-amber-500/20 text-amber-300 border-amber-500/30" },
  bezahlt:                 { label: "Bezahlt", cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
  ueberfaellig:            { label: "Überfällig", cls: "bg-red-500/20 text-red-300 border-red-500/30" },
  mahnung:                 { label: "Mahnung", cls: "bg-red-500/20 text-red-300 border-red-500/30" },
  eskalation:              { label: "Eskalation", cls: "bg-red-600/25 text-red-200 border-red-500/40" },
};

export const PAYMENT_STAGE_STATUS = {
  planned:   { label: "Geplant", cls: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
  requested: { label: "Angefordert", cls: "bg-blue-500/20 text-blue-300 border-blue-500/30" },
  invoiced:  { label: "Fakturiert", cls: "bg-amber-500/20 text-amber-300 border-amber-500/30" },
  paid:      { label: "Bezahlt", cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
  overdue:   { label: "Überfällig", cls: "bg-red-500/20 text-red-300 border-red-500/30" },
  reminded:  { label: "Erinnert", cls: "bg-orange-500/20 text-orange-300 border-orange-500/30" },
  dunned:    { label: "Mahnung", cls: "bg-red-500/20 text-red-300 border-red-500/30" },
  escalated: { label: "Eskalation", cls: "bg-red-600/25 text-red-200 border-red-500/40" },
};

export const INVOICE_STATUS = {
  draft:     { label: "Entwurf", cls: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
  issued:    { label: "Offen", cls: "bg-amber-500/20 text-amber-300 border-amber-500/30" },
  paid:      { label: "Bezahlt", cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
  overdue:   { label: "Überfällig", cls: "bg-red-500/20 text-red-300 border-red-500/30" },
  cancelled: { label: "Storniert", cls: "bg-slate-500/20 text-slate-500 border-slate-500/30" },
};

// Grandmont Core workforce integration — Assignment / Absence presentation labels.
// Internal API values (active/completed/cancelled, pending/approved/rejected, ...) are
// never renamed — only their Russian display label lives here.
export const ASSIGNMENT_STATUS = {
  active:    { label: "Активно",   cls: "bg-blue-500/20 text-blue-300 border-blue-500/30" },
  completed: { label: "Завершено", cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
  cancelled: { label: "Отменено",  cls: "bg-slate-500/20 text-slate-500 border-slate-500/30" },
};

export const ABSENCE_STATUS = {
  pending:   { label: "На согласовании", cls: "bg-amber-500/20 text-amber-300 border-amber-500/30" },
  approved:  { label: "Согласовано",     cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
  rejected:  { label: "Отклонено",       cls: "bg-red-500/20 text-red-300 border-red-500/30" },
  cancelled: { label: "Отменено",        cls: "bg-slate-500/20 text-slate-500 border-slate-500/30" },
};

export const ABSENCE_TYPE = {
  vacation: "Отпуск",
  sick:     "Больничный",
  day_off:  "Отгул",
  personal: "Личные обстоятельства",
  other:    "Другое",
};

// ---- Europe/Berlin time helpers (Grandmont Core requires timezone-aware
// datetimes; the browser's own locale/timezone is never assumed to be Berlin) ----
const BERLIN_TZ = "Europe/Berlin";

function berlinOffsetMinutes(utcDate) {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-US", {
      timeZone: BERLIN_TZ, hour12: false,
      year: "numeric", month: "2-digit", day: "2-digit",
      hour: "2-digit", minute: "2-digit", second: "2-digit",
    }).formatToParts(utcDate).map((p) => [p.type, p.value])
  );
  const asUtc = Date.UTC(
    +parts.year, +parts.month - 1, +parts.day,
    parts.hour === "24" ? 0 : +parts.hour, +parts.minute, +parts.second
  );
  return (asUtc - utcDate.getTime()) / 60000;
}

// "YYYY-MM-DDTHH:mm" (as entered by an admin, meant as Berlin wall-clock time) -> UTC ISO string
export function berlinLocalToUtcIso(dateTimeLocalValue) {
  if (!dateTimeLocalValue) return null;
  const [datePart, timePart] = dateTimeLocalValue.split("T");
  const [y, m, d] = datePart.split("-").map(Number);
  const [hh, mm] = (timePart || "00:00").split(":").map(Number);
  const guessUtcMs = Date.UTC(y, m - 1, d, hh, mm);
  const offsetMin = berlinOffsetMinutes(new Date(guessUtcMs));
  return new Date(guessUtcMs - offsetMin * 60000).toISOString();
}

// Any ISO datetime -> "YYYY-MM-DDTHH:mm" for a datetime-local input, in Berlin wall-clock time
export function isoToBerlinLocalInput(iso) {
  if (!iso) return "";
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-US", {
      timeZone: BERLIN_TZ, hour12: false,
      year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit",
    }).formatToParts(new Date(iso)).map((p) => [p.type, p.value])
  );
  const hh = parts.hour === "24" ? "00" : parts.hour;
  return `${parts.year}-${parts.month}-${parts.day}T${hh}:${parts.minute}`;
}

export function fmtBerlinDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("ru-RU", {
      timeZone: BERLIN_TZ, day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
    }) + " (Берлин)";
  } catch { return iso; }
}
